export const WarningIcon = ({size = 15, fill = "#FF6B00"}: {size?: number; fill?: string}) => {
  return (
    <svg
      data-testid="warning-icon"
      width={size}
      height={size}
      style={{cursor: "pointer"}}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 14.7059C9.48912 14.7059 11.3968 13.9312 12.8033 12.5523C14.2098 11.1733 15 9.30306 15 7.35294C15 5.40282 14.2098 3.53257 12.8033 2.15363C11.3968 0.774683 9.48912 0 7.5 0C5.51088 0 3.60322 0.774683 2.1967 2.15363C0.790176 3.53257 0 5.40282 0 7.35294C0 9.30306 0.790176 11.1733 2.1967 12.5523C3.60322 13.9312 5.51088 14.7059 7.5 14.7059ZM7.5 3.67647C7.88965 3.67647 8.20312 3.9838 8.20312 4.36581V7.58272C8.20312 7.96473 7.88965 8.27206 7.5 8.27206C7.11035 8.27206 6.79688 7.96473 6.79688 7.58272V4.36581C6.79688 3.9838 7.11035 3.67647 7.5 3.67647ZM6.5625 10.1103C6.5625 9.86653 6.66127 9.63275 6.83709 9.46038C7.0129 9.28801 7.25136 9.19118 7.5 9.19118C7.74864 9.19118 7.9871 9.28801 8.16291 9.46038C8.33873 9.63275 8.4375 9.86653 8.4375 10.1103C8.4375 10.3541 8.33873 10.5878 8.16291 10.7602C7.9871 10.9326 7.74864 11.0294 7.5 11.0294C7.25136 11.0294 7.0129 10.9326 6.83709 10.7602C6.66127 10.5878 6.5625 10.3541 6.5625 10.1103Z"
        fill={fill}
      />
    </svg>
  );
};
